/**
 * r7e_domain_base_app.js
 * 
 * Provides the R7E_DomainBaseApp class for domain-based authentication and account management,
 * as well as the R7E_IApplication interface for account-type-specific app wrappers.
 * 
 * Exports:
 *   - R7E_DomainBaseApp (default instance: r7eBaseApp)
 *   - R7E_IApplication
 *   - R7eAccountTypeError
 */

import { R7E_DomainAuth } from './domain_auth.js';
import { R7E_IBaseApp, R7eAccountTypeError, R7E_IApplication, DEBUG_MODE, R7E_NavBarData, R7E_HomeItem } from '../r7e_base.js';

// --- Custom Error for Account Type Issues ---
// Re-used from shared implementation (r7e_base_app_i)

/**
 * R7E_DomainBaseApp
 * Extends the shared base with domain-specific auth and helpers.
 */
class R7E_DomainBaseApp extends R7E_IBaseApp {
    constructor() {
        super(new R7E_DomainAuth());
        this.baseAppType = 'domain';
    }

    // --- Domain-specific Methods ---
    getAuthDomain() { return this.auth.getAuthDomain(); }
    setAuthDomain(domain) { this.auth.setAuthDomain(domain); }
    setCrossOriginMessagingEnabled(enabled) { this.auth.setCrossOriginMessagingEnabled(enabled); }

    // // --- Authenticated State ---
    // isAuthenticated() {
    //     return this.auth.isAuthenticated();
    // }
    // hasPendingRegistration() {
    //     return this.auth.hasPendingRegistration();
    // }
}

// --- Exported Singleton Instance ---
const r7eBaseApp = new R7E_DomainBaseApp();

export { R7E_IApplication, R7eAccountTypeError, r7eBaseApp, DEBUG_MODE, R7E_NavBarData, R7E_HomeItem };
export default r7eBaseApp;
